import axios from 'axios';
import { ITransactionEntityAttributes, TransactionEntity } from '../../Models/Entities';

interface TransactionExpiryResponse extends ITransactionEntityAttributes {
	id: string;
	secondsUntilExpiry?: number;
}

export async function fetchTransactionById(transactionId: string) {
	const response = await axios.get<TransactionExpiryResponse>(
		`/api/entity/TransactionEntity/${transactionId}/expiry`,
	);
	return { data: [new TransactionEntity(response.data)] };
}
